










































































































import { Component, Vue, Ref } from 'vue-property-decorator';
import hexabaseState from '@/store/hexabase';
//import userState from '@/store/user';
import { customerEditOptionalForm } from '@/constants/form/customerForm';
import {
  registerFinishText,
  registerFinishAction,
  editFinishText,
  editFinishAction,
  customerDepartmentDetailsHeaders,
  matterBasicDetailsHeaders,
  customerInitialAction,
  toolTipsMessage
} from '@/constants/customer/customer';
import {
  FieldChildrenProp,
  ActionFieldSeeting,
  StatusActions,
  ItemActions,
  ActionButtons,
  StatusList,
  FieldsInfo,
  HexaFileFieldResponse
} from '@/services/hexabase/types';
import { TableColumn, TableParameters } from '@/constants/components/table';

import { customerRules } from '@/constants/form/inputCheck';

import Customer from '@/models/customerModel';

import Header from '@/components/common/modules/Header.vue';
import SideMenu from '@/components/common/modules/SideMenu.vue';
import PageInfoBar from '@/components/common/modules/PageInfoBar.vue';
import ActionButtonPanel from '@/components/common/modules/ActionButtonPanel.vue';
import CreateBasicInfo from '@/components/sample/detail/CreateBasicInfo.vue';
import TransitionDialog from '@/components/common/modules/TransitionDialog.vue';
import Dialog from '@/components/common/modules/Dialog.vue';
import ExecAction from '@/components/common/modules/ExecAction.vue';
import IconTextLink from '@/components/common/elements/IconTextLink.vue';
// import { DateTime } from 'luxon';

import CustomerBasicInfoPanel from '@/components/customer/detail/CustomerBasicInfoPanel.vue';
import ActionButtonWithTablePanel from '@/components/common/modules/ActionButtonWithTablePanel.vue';

interface Rules {
  id: string;
  rule: string[];
  referenceField?: {
    id: string;
    rule: string;
  }[];
}
interface MatterFieldsItems {
  id?: string;
  project_id?: string;
  project_name?: string;
  status?: string;
  service_type_id?: string;
  service_type_name?: string;
  i_id?: string;
}
interface DepartmentFieldsItems {
  id?: string;
  department_id?: string;
  department_name?: string;
  manager?: string;
  manager_email?: string;
  telephone_number?: string;
  head_office_judgment_flag?: string;
  i_id?: string;
  rev_no: string;
}
interface EditCustomerDepertitem {
  postal_code?: string;
  prefectures?: string;
  municipalities?: string;
  machimura_street_address?: string;
  building_name?: string;
  manager?: string;
  manager_email?: string;
  telephone_number?: string;
  cell_phone_number?: string;
  rev_no?: string;
}

interface LinkedFileds {
  as_title: boolean;
  dataType: string;
  display_id: string;
  display_name: string;
  f_id: string;
  fieldIndex: number;
  full_text: boolean;
  has_index: boolean;
  hideOnInput: boolean;
  hide_from_api: boolean;
  id: string;
  name: string;
  search: boolean;
  show_list: boolean;
  status: boolean;
  title_order: number;
  unique: boolean;
}
interface SelectOptions {
  option_id: string;
  sort_id: 0;
  value: string;
  enabled: true;
  color: string;
  display_id: string;
  text: string;
}
interface FieldValues {
  field_id: string;
  field_name: string;
  dataType: string;
  value: string;
  sizeX: number;
  sizeY: number;
  col: number;
  row: number;
}
/** ヘキサベースのID値を参照するためのエリア：事前設定必要 */
interface ReferenceValueArea {
  /**本社拠点フラグ：本社 */
  head_office_judgment_flag_head_office: string;
  /**本社拠点フラグ：拠点 */
  head_office_judgment_flag_department: string;
  /**顧客区分：法人 */
  customer_class_houjin: string;
  /**顧客区分：個人 */
  customer_class_kojin: string;
}
@Component({
  components: {
    Header,
    SideMenu,
    PageInfoBar,
    ActionButtonPanel,
    CreateBasicInfo,
    TransitionDialog,
    Dialog,
    CustomerBasicInfoPanel,
    ActionButtonWithTablePanel,
    ExecAction,
    IconTextLink
  }
})
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
export default class CustomerEdit extends Vue {
  @Ref() basicinfopanel: CustomerBasicInfoPanel | undefined;

  private projectId = hexabaseState.applicationId;
  private customer = new Customer();

  // 各入力フィールド情報格納プロパティ
  private basicFieldsData: Array<FieldChildrenProp> = [];
  private basicFieldCols = '';

  // マスタデータ関連格納プロパティ
  // private masterData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};

  private subPanelListName = '部署・拠点一覧';
  private subPanelLabel = '';
  private subPanelFieldCols: any = [];
  private subPanelFieldsData: Array<Array<FieldChildrenProp>> = [];

  // dbID格納プロパティ
  private mainDsId = '';
  private relatedDsIdMat = '';
  private relatedDsIdDep = '';

  // 登録用情報格納プロパティ
  private registData: any = {
    item: {},
    return_item_result: true, // true指定すると、登録されたアイテム情報を返します
    related_ds_items: {} // 関連するデータストアの新規・更新・削除を指定  詳細は以下を参照
  };
  private registFieldType: any = {};

  // アイテム登録後ダイアログ
  private dialogStatus = false;
  private isLoading = false;
  private registerText = this.customer.deepCopy(registerFinishText);
  private editText = this.customer.deepCopy(editFinishText);
  private buttonText: string = this.editText;
  private registerbuttons: Array<{ [k: string]: string | number }> = this.customer.deepCopy(
    registerFinishAction
  );
  private editButtons: Array<{ [k: string]: string | number }> = this.customer.deepCopy(
    editFinishAction
  );
  private buttons = this.editButtons;
  // 案件情報関連
  private matterFieldCols: Array<TableColumn> = this.customer.deepCopy(matterBasicDetailsHeaders);
  private matterFieldsData?: Array<{ [k: string]: string }> = [];
  private matterTableParams?: TableParameters = {
    columns: this.matterFieldCols,
    body: this.matterFieldsData,
    perPage: -1,
    tableText: '',
    buttonItems: [
      {
        alwaysDisplayed: false,
        class: 'btn-normal',
        name: 'detail',
        text: '詳細',
        disabled: false
      }
    ]
  };
  private statusButton2: Array<StatusActions> = [
    {
      action_id: '',
      display_id: '',
      action_name: '新規案件登録',
      display_order: 0,
      crud_type: '1',
      next_status_id: '',
      isDisable: false
    }
  ];

  // 顧客部署情報関連
  //customerDepartmentDetailsHeaders
  private departFieldCols: Array<TableColumn> = this.customer.deepCopy(
    customerDepartmentDetailsHeaders
  );
  private departFieldsData?: Array<{ [k: string]: string }> = [];
  private departTableParams?: TableParameters = {
    columns: this.departFieldCols,
    body: this.departFieldsData,
    perPage: -1,
    tableText: '',
    buttonItems: [
      {
        alwaysDisplayed: false,
        class: 'btn-normal',
        name: 'detail',
        text: '詳細',
        disabled: false
      }
    ]
  };
  private statusButton3: Array<StatusActions> = [
    {
      action_id: '',
      display_id: '',
      action_name: '新規部署登録',
      display_order: 0,
      crud_type: '1',
      next_status_id: '',
      isDisable: false
    }
  ];
  private departHontenId = '';
  private departHontenrevno = '';

  // 初期ステータス
  private displayStatus = '';

  private ActionButtonType = '';

  // 編集対象アイテム情報
  private itemId = this.$route.params.id;
  private revNumber = 0;
  private currentData: Array<FieldsInfo> = [];
  // private currentDetailData: any = [];

  // アクション情報格納プロパティ
  private statusButton: Array<StatusActions> = [];
  private statusAction: Array<StatusActions> = [];
  private itemActions: Array<ItemActions> = [];
  // private detailStatusAction: Array<StatusActions> = [];
  // private detailItemActions: Array<ItemActions> = [];
  private execAllowActions: Array<ActionButtons> = [];
  private execAllowActionsByDetail: Array<ActionButtons> = [];
  private selectAction = '';
  private isExecDialog = false;
  private execDialogMessage = '重複するデータが存在します。登録を続けますか？';
  private execDialogTitle = '登録確認';
  private isExecDialog2 = false;
  private execDialogMessage2 =
    '画面遷移を行うと入力中の内容は保存されません。遷移しても良いですか？';
  private execDialogTitle2 = '画面遷移確認';
  private waitingForDialog = '';
  private jumpIid = '';

  // ステータス情報格納プロパティ
  private statusList: Array<StatusList> = [];
  private statusRules: { [k: string]: Rules[] } = {};
  private enableSubPanel = false;
  private subpanelState = true;
  private unshowdId = ['birthday', 'sex'];
  private enablePersonalCol = false;
  private unshowdCorporateId = ['corporate_number'];
  private enableCorporateCol = false;
  private buttonCrudType = '';

  /** 顧客基本情報インフォ用 */
  private toolTipsTextBasicInfoMain = '';
  /** 顧客部署リストインフォ用 */
  private toolTipsTextBasicInfoDepartmentList = '';
  /** 案件情報リストインフォ用 */
  private toolTipsTextBasicInfoMatterList = '';

  private defaultOption: SelectOptions = {
    option_id: '',
    sort_id: 0,
    value: '',
    enabled: true,
    color: '',
    display_id: '',
    text: ''
  };

  private referenceValue: ReferenceValueArea = {
    head_office_judgment_flag_head_office: '',
    head_office_judgment_flag_department: '',
    customer_class_houjin: '',
    customer_class_kojin: ''
  };

  get refs(): any {
    return this.$refs;
  }

  async created() {
    if (this.$route.query.querytest !== undefined) {
      this.ActionButtonType = String(this.$route.query.querytest);
    }

    try {
      // ローディングをセット
      this.$store.commit('hexabase/setIsLoading', true);

      this.mainDsId = hexabaseState.datastoreIds['顧客マスタ'];
      this.relatedDsIdMat = hexabaseState.datastoreIds['案件基本情報'];
      this.relatedDsIdDep = hexabaseState.datastoreIds['顧客部署マスタ'];

      const [basicResult, newActionMat, newActionDep] = await Promise.all([
        this.customer.getLinkedItems(hexabaseState.applicationId, this.mainDsId, this.itemId),
        this.customer.getNewActionList(this.relatedDsIdMat),
        this.customer.getNewActionList(this.relatedDsIdDep)
      ]);
      // tooltips情報を後設定出来るよう修正
      this.toolTipsTextBasicInfoMain = this.customer.deepCopy(
        toolTipsMessage['customer_toolTipsTextBasicInfoMain']
      );
      this.toolTipsTextBasicInfoDepartmentList = this.customer.deepCopy(
        toolTipsMessage['customer_toolTipsTextDepartmentList']
      );
      this.toolTipsTextBasicInfoMatterList = this.customer.deepCopy(
        toolTipsMessage['customer_toolTipsTextMatterList']
      );

      // 削除済みのデータは操作させない
      const wkdata1: Array<FieldValues> = basicResult['field_values'];
      const wkStList: Array<StatusList> = basicResult['status_list'];
      const wkStatus = wkStList.find(
        v => v.status_id === (wkdata1.find(v => v.dataType === 'status')?.value || '')
      )?.status_name;
      this.displayStatus = wkStatus === '有効' ? '' : wkStatus || '';
      if (this.displayStatus !== '削除済') {
        if (newActionMat.actions === undefined || newActionMat.actions.length === 0) {
          this.statusButton2.splice(0);
        }
        if (newActionDep.actions === undefined || newActionDep.actions.length === 0) {
          this.statusButton3.splice(0);
        }
      } else {
        this.statusButton2.splice(0);
        this.statusButton3.splice(0);
        if (
          this.matterTableParams !== undefined &&
          this.matterTableParams.buttonItems !== undefined
        ) {
          const itemsLength1 = this.matterTableParams.buttonItems.length;
          for (let index1 = 0; index1 < itemsLength1; index1++) {
            this.$set(this.matterTableParams.buttonItems[index1], 'disabled', true);
          }
        }
        if (
          this.departTableParams !== undefined &&
          this.departTableParams.buttonItems !== undefined
        ) {
          const itemsLength2 = this.departTableParams.buttonItems.length;
          for (let index2 = 0; index2 < itemsLength2; index2++) {
            this.$set(this.departTableParams.buttonItems[index2], 'disabled', true);
          }
        }
      }

      /** 関連付けされた案件情報 */
      const LinkdMatterData = this.getMatterData(
        basicResult.linked_items[this.relatedDsIdMat].fields,
        basicResult.linked_items[this.relatedDsIdMat].items
      );
      if (LinkdMatterData !== undefined) {
        //LinkdMatterData
        LinkdMatterData.forEach(i => {
          const Pushdata: { [k: string]: string } = {
            project_id: i.project_id || '',
            project_name: i.project_name || '',
            status: i.status || '',
            service_type_id: i.service_type_id || '',
            service_type_name: i.service_type_name || '',
            id: i.id || '',
            i_id: i.i_id || ''
          };
          this.matterFieldsData?.push(Pushdata);
        });
      }

      /** 関連付けされた顧客部署情報 */
      const LinkdDepartmentData = this.getDepartmentData(
        basicResult.linked_items[this.relatedDsIdDep].fields,
        basicResult.linked_items[this.relatedDsIdDep].items
      );
      //const LinkdDepartmentData
      if (LinkdDepartmentData !== undefined) {
        LinkdDepartmentData.forEach(i => {
          const Pushdata2: { [k: string]: string } = {
            department_id: i.department_id || '',
            department_name: i.department_name || '',
            manager: i.manager || '',
            manager_email: i.manager_email || '',
            telephone_number: i.telephone_number || '',
            head_office_judgment_flag: i.head_office_judgment_flag || '',
            id: i.id || '',
            i_id: i.i_id || '',
            rev_no: i.rev_no || ''
          };
          if (
            i.head_office_judgment_flag !== undefined &&
            i.head_office_judgment_flag === '拠点部署'
          ) {
            this.departFieldsData?.push(Pushdata2);
          } else if (
            i.head_office_judgment_flag !== undefined &&
            i.head_office_judgment_flag === '本社'
          ) {
            this.departHontenId = Pushdata2.i_id;
            this.departHontenrevno = Pushdata2.rev_no;
          }
        });
      }

      if (this.customer.isNullOrUndefined(basicResult.status_actions))
        basicResult.status_actions.forEach((v: StatusActions) => this.statusAction.push(v));
      if (this.customer.isNullOrUndefined(basicResult.item_actions))
        basicResult.item_actions.forEach((v: ItemActions) => this.itemActions.push(v));
      if (this.customer.isNullOrUndefined(basicResult.status_list))
        basicResult.status_list.forEach((v: StatusList) => this.statusList.push(v));
      // ステータス移管に使用するためリビジョン番号を格納
      this.revNumber = basicResult.rev_no;
      // DB登録用データを作成
      this.currentData = basicResult.field_values;
      for (const key in this.currentData) {
        if (this.currentData[key].value !== undefined && this.currentData[key].value !== null) {
          let value = this.currentData[key].value;
          if (
            this.currentData[key].dataType === 'dslookup' &&
            typeof this.currentData[key].value === 'object' &&
            this.currentData[key].value !== null &&
            this.currentData[key].value.item_id !== undefined
          ) {
            value = this.currentData[key].value.item_id;
          }
          if (this.currentData[key].dataType === 'file') {
            value =
              this.currentData[key].value.length === 0
                ? []
                : (this.currentData[key].value as HexaFileFieldResponse[])
                    .map(file => file.file_id)
                    .filter(v => v);
          }
          this.registData.item[this.currentData[key].field_id] = value;
        }
      }

      this.execAllowActions = this.statusAction as Array<ActionButtons>;
      await this.getBasicFields();
      this.basicinfopanel?.initSubPanel(this.subpanelState, this.enableSubPanel);
      this.statusButton = this.customer.statusButtonList(this.execAllowActions, this.currentData);
    } catch (e) {
      console.log(e);
      this.setError(e);
    } finally {
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  /**
   * 紐づけ情報から案件一覧を取得
   */
  /* eslint-disable prefer-const */
  private getMatterData(fields: Array<LinkedFileds>, items: any): Array<MatterFieldsItems> {
    let vData = [];
    const sArray = Object.entries(fields);
    const sItem = Object.entries(items);
    const index1 = sArray.findIndex(v => v[1].display_id === 'id');
    const index2 = sArray.findIndex(v => v[1].display_id === 'project_id');
    const index3 = sArray.findIndex(v => v[1].display_id === 'project_name');
    const index4 = sArray.findIndex(v => v[1].display_id === 'Status');
    const index5 = sArray.findIndex(v => v[1].display_id === 'service_type_id');
    const find1 = sArray[index1][1].f_id;
    const find2 = sArray[index2][1].f_id;
    const find3 = sArray[index3][1].f_id;
    const find4 = sArray[index4][1].f_id;
    const find5 = sArray[index5][1].f_id;
    // サービス種別を取得
    const itemslangs = Object.keys(items).length;
    for (let index = 0; index < itemslangs; index++) {
      let sData: MatterFieldsItems = {
        id: '',
        project_id: '',
        project_name: '',
        status: '',
        service_type_id: '',
        service_type_name: '',
        i_id: ''
      };
      const wkItem: any = sItem[index][1];
      if (wkItem[find4] === '削除済') {
        continue;
      }
      const lookupdata = wkItem['lookup_items'][find5]['title'];
      this.$set(sData, 'id', wkItem[find1]);
      this.$set(sData, 'project_id', wkItem[find2]);
      this.$set(sData, 'project_name', wkItem[find3]);
      this.$set(sData, 'status', wkItem[find4]);
      this.$set(sData, 'service_type_id', wkItem[find5]);
      this.$set(sData, 'service_type_name', lookupdata);
      this.$set(sData, 'i_id', wkItem['i_id']);
      vData.push(sData);
    }
    return vData;
  }
  /* eslint-enable prefer-const */

  /**
   * 紐づけ情報から案件一覧を取得
   */
  /* eslint-disable prefer-const */
  private getDepartmentData(fields: Array<LinkedFileds>, items: any): Array<DepartmentFieldsItems> {
    let vData = [];
    const sArray = Object.entries(fields);
    const sItem = Object.entries(items);
    const index1 = sArray.findIndex(v => v[1].display_id === 'id');
    const index2 = sArray.findIndex(v => v[1].display_id === 'department_id');
    const index3 = sArray.findIndex(v => v[1].display_id === 'department_name');
    const index4 = sArray.findIndex(v => v[1].display_id === 'manager');
    const index5 = sArray.findIndex(v => v[1].display_id === 'telephone_number');
    const index6 = sArray.findIndex(v => v[1].display_id === 'manager_email');
    const index7 = sArray.findIndex(v => v[1].display_id === 'head_office_judgment_flag');
    // TODO:開発環境でHexabase管理画面からステータス画面項目IDが変更できないため、display_nameで判定する
    // IDが変更できるようになったら'Status'に変更し、PGを元の判定に戻す
    //const index8 = sArray.findIndex(v => v[1].display_id === 'Status');
    const index8 = sArray.findIndex(v => v[1].display_name === 'ステータス');
    const find1 = sArray[index1][1].f_id;
    const find2 = sArray[index2][1].f_id;
    const find3 = sArray[index3][1].f_id;
    const find4 = sArray[index4][1].f_id;
    const find5 = sArray[index5][1].f_id;
    const find6 = sArray[index6][1].f_id;
    const find7 = sArray[index7][1].f_id;
    const find8 = sArray[index8][1].f_id;
    const itemslangs = Object.keys(items).length;
    for (let index = 0; index < itemslangs; index++) {
      let sData: DepartmentFieldsItems = {
        id: '',
        department_id: '',
        department_name: '',
        manager: '',
        manager_email: '',
        telephone_number: '',
        head_office_judgment_flag: '',
        i_id: '',
        rev_no: ''
      };
      const wkItem: any = sItem[index][1];
      if (wkItem[find8] === '削除済') {
        continue;
      }
      this.$set(sData, 'id', wkItem[find1]);
      this.$set(sData, 'department_id', wkItem[find2]);
      this.$set(sData, 'department_name', wkItem[find3]);
      this.$set(sData, 'manager', wkItem[find4]);
      this.$set(sData, 'telephone_number', wkItem[find5]);
      this.$set(sData, 'manager_email', wkItem[find6]);
      this.$set(sData, 'head_office_judgment_flag', wkItem[find7]);
      this.$set(sData, 'i_id', wkItem['i_id']);
      this.$set(sData, 'rev_no', wkItem['rev_no']);
      vData.push(sData);
    }
    return vData;
  }
  /* eslint-enable prefer-const */

  /**
   * 基本情報入力フォームを生成するための設定情報を取得・整形します
   */
  private async getBasicFields() {
    try {
      const initialAction = this.customer.getFormDisplayAction(
        this.itemActions,
        customerInitialAction
      );
      const [inputFields, fieldsData, fieldsData2] = await Promise.all([
        this.customer.getFieldsByActionId(this.mainDsId, initialAction!.action_id),
        this.customer.makeFieldsList(this.projectId, this.mainDsId, this.currentData),
        this.customer.makeFieldsList(this.projectId, this.relatedDsIdDep)
      ]);
      // データ登録時の為各フィールドのデータ型を格納
      for (const key in inputFields.action_fields) {
        this.registFieldType[inputFields.action_fields[key].display_id] =
          inputFields.action_fields[key].dataType;
      }
      const data = this.customer
        .addOptionalFormField(
          fieldsData.filter(v => v.dataType !== 'status'),
          this.customer.deepCopy(customerEditOptionalForm)
        )
        .map(field => this.customer.inputRestriction(field, inputFields))
        .map(field => this.customer.setSelectAreaItemId(field))
        .map(field => this.customer.setPropsByLocalProperty(field, this))
        .map(field => {
          if (field.dataType === 'dslookup') {
            field.props!.isBtnVisible = false;
          }
          field.props!.isReadonly = true;
          field.props!.isDisabled = true;
          return field;
        });

      // ID値を退避
      await this.setReferenceArea(fieldsData, fieldsData2);

      // フォーカス調整のため要素を並べ替え
      const sortwk1 = data.sort(function(a, b) {
        return (a.col || 0) - (b.col || 0);
      });
      const sortwk2 = sortwk1.sort(function(a, b) {
        return (a.row || 0) - (b.row || 0);
      });
      this.basicFieldCols = this.customer.getGridStatus(sortwk2);
      this.basicFieldsData = this.chkUnShowd(data);
    } catch (error) {
      console.log(error);
      this.setError(error);
    }
  }

  /**
   * 選択値等IDが必要なものを参照するために事前セットをする
   */
  private async setReferenceArea(
    fieldsData1: Array<FieldChildrenProp>,
    fieldsData2: Array<FieldChildrenProp>
  ) {
    // 顧客区分
    const index_cco = fieldsData1.findIndex(v => v.display_id === 'customer_class');
    const wk_cco: any = fieldsData1[index_cco];
    const customer_class_option: Array<SelectOptions> = wk_cco.options || this.defaultOption;
    this.referenceValue.customer_class_houjin =
      customer_class_option.find(V => V.text === '法人')?.option_id || '';
    this.referenceValue.customer_class_kojin =
      customer_class_option.find(V => V.text === '個人')?.option_id || '';
    // 顧客マスタ＿本社拠点判定用フラグ
    const index_jfd = fieldsData2.findIndex(v => v.display_id === 'head_office_judgment_flag');
    const wk_jfd: any = fieldsData2[index_jfd];
    const head_office_judgment_flag_option: Array<SelectOptions> =
      wk_jfd.options || this.defaultOption;
    this.referenceValue.head_office_judgment_flag_head_office =
      head_office_judgment_flag_option.find(V => V.text === '本社')?.option_id || '';
    this.referenceValue.head_office_judgment_flag_department =
      head_office_judgment_flag_option.find(V => V.text === '拠点部署')?.option_id || '';
  }

  /**
   * 初期表示時の非表示フィールドの調整
   */
  /* eslint-disable prefer-const */
  private chkUnShowd(FieldsData: FieldChildrenProp[]) {
    try {
      let retFields = FieldsData;
      const index = FieldsData.findIndex(v => v.display_id === 'customer_class');
      const chkValue = FieldsData[index].props?.value;
      const chkSelect: Array<any> = FieldsData[index].props?.selectData.options;
      const chkText = chkSelect.find(v => v.option_id === chkValue).text;
      const index2 = FieldsData.findIndex(v => v.display_id === 'birthday');
      const index3 = FieldsData.findIndex(v => v.display_id === 'sex');
      const index4 = FieldsData.findIndex(v => v.display_id === 'corporate_number');
      if (chkText !== undefined && chkText === '個人') {
        retFields[index2].show = true;
        retFields[index3].show = true;
        retFields[index4].show = false;
        this.enableSubPanel = false;
      } else {
        retFields[index2].show = false;
        retFields[index3].show = false;
        retFields[index4].show = true;
        this.enableSubPanel = true;
      }
      return retFields;
    } catch {
      return FieldsData;
    }
  }
  /* eslint-enable prefer-const */

  /**
   * 子コンポーネントからEmitされる値インサート用に加工（基本情報）
   * 主にPropsの変更を行う
   * @module catchInputBasic
   * @param {any} response - 子コンポーネントより渡される値
   * @return {void}
   */
  private catchInputBasic(response: any) {
    const index = this.basicFieldsData.findIndex(v => v.display_id === response.name);
    switch (this.basicFieldsData[index].component) {
      case 'MasterSelectControl':
      case 'MasterSelectSetControl':
      case 'MasterSelectMultiControl':
      case 'MasterSelectMultiSetControl':
        this.$set(this.basicFieldsData[index].props!, 'value', { item_id: response.value });
        break;
      default:
        this.$set(this.basicFieldsData[index].props!, 'value', response.value);
    }
    if (
      response.name !== undefined &&
      response.text !== undefined &&
      response.name === 'customer_class'
    ) {
      switch (response.text) {
        case '法人': {
          const indexH1 = this.basicFieldsData.findIndex(v => v.display_id === 'birthday');
          const indexH2 = this.basicFieldsData.findIndex(v => v.display_id === 'sex');
          const indexH3 = this.basicFieldsData.findIndex(v => v.display_id === 'corporate_number');
          this.$set(this.basicFieldsData[indexH1], 'show', false);
          this.$set(this.basicFieldsData[indexH2], 'show', false);
          this.$set(this.basicFieldsData[indexH3], 'show', true);
          // バリデーションルールを付与する
          this.$set(this.basicFieldsData[indexH3].props!, 'rules', 'numeric|corporate_number_lengthCheck:13');
          break;
        }
        case '個人': {
          const indexK1 = this.basicFieldsData.findIndex(v => v.display_id === 'birthday');
          const indexK2 = this.basicFieldsData.findIndex(v => v.display_id === 'sex');
          const indexH3 = this.basicFieldsData.findIndex(v => v.display_id === 'corporate_number');
          this.$set(this.basicFieldsData[indexK1], 'show', true);
          this.$set(this.basicFieldsData[indexK2], 'show', true);
          this.$set(this.basicFieldsData[indexH3], 'show', false);
          // バリデーションルールを削除する
          this.$set(this.basicFieldsData[indexH3].props!, 'rules', '');
          break;
        }
      }
    }
  }

  /**
   * ルーター設定ファイルよりパンくずリスト取得
   * @module getBreadCrumbs
   * @return {array} - breadcrumbs 情報
   */
  private getBreadCrumbs(): [] {
    if (this.$route.matched.some(obj => obj.meta.breadcrumbs)) {
      return this.$route.meta.breadcrumbs;
    }
    return [];
  }

  /**
   * 基本情報パネルで入力された値を受け取り登録データに渡す
   * @public response - インサート用に整形されたデータ
   * @returns void
   */
  private createBasicData(response: any): void {
    this.registData.item = response;
  }

  /**
   * 「案件情報」
   * テーブル内のボタンを押下した際の処理
   **/
  private clickButtonMat(response: any): void {
    switch (response.buttonName) {
      case 'detail': {
        //選択したIDの詳細処理へ遷移
        const iid = response.record.i_id || '';
        if (this.selectAction !== undefined && this.selectAction === 'customer_valid_update') {
          this.waitingForDialog = 'MatEdit';
          this.jumpIid = iid;
          this.isExecDialog2 = true;
        } else if (
          this.selectAction !== undefined &&
          this.selectAction !== 'customer_valid_delete'
        ) {
          this.$router.push({ name: 'MatterEdit', params: { id: iid }, query: {} });
        }
        break;
      }
    }
  }

  /**
   * 「案件情報」
   * アクションパネルのボタンを押下した際の処理
   **/
  private async buttonActionMat() {
    // 新規登録処理へ遷移
    try {
      if (this.selectAction !== undefined && this.selectAction === 'customer_valid_update') {
        this.waitingForDialog = 'MatRegist';
        this.jumpIid = '';
        this.isExecDialog2 = true;
      } else if (this.selectAction !== undefined && this.selectAction !== 'customer_valid_delete') {
        this.$router.push({ name: 'MatterRegisterWithId', params: { id: this.itemId }, query: {} });
      }
      //
    } catch (error) {
      let errorMessage = 'Failed to do something exceptional';
      if (error instanceof Error) {
        errorMessage = error.message;
      }
      this.setError(errorMessage);
    }
  }

  /**********/

  /**
   * 「顧客部署」
   * テーブル内のボタンを押下した際の処理
   **/
  private clickButtonDep(response: any): void {
    switch (response.buttonName) {
      case 'detail': {
        //選択したIDの詳細処理へ遷移
        const iid2 = response.record.i_id || '';
        if (this.selectAction !== undefined && this.selectAction === 'customer_valid_update') {
          this.waitingForDialog = 'DepEdit';
          this.jumpIid = iid2;
          this.isExecDialog2 = true;
        } else if (
          this.selectAction !== undefined &&
          this.selectAction !== 'customer_valid_delete'
        ) {
          this.$router.push({ name: 'CustomerDepartmentEdit', params: { id: iid2 }, query: {} });
        }
        break;
      }
    }
  }

  /**
   * 「顧客部署」
   * アクションパネルのボタンを押下した際の処理
   **/
  private async buttonActionDep() {
    // 新規登録処理へ遷移

    try {
      if (this.selectAction !== undefined && this.selectAction === 'customer_valid_update') {
        this.waitingForDialog = 'DepRegist';
        this.jumpIid = '';
        this.isExecDialog2 = true;
      } else if (this.selectAction !== undefined && this.selectAction !== 'customer_valid_delete') {
        this.$router.push({
          name: 'CustomerDepartmentRegister',
          params: { id: this.itemId },
          query: {}
        });
      }
    } catch (error) {
      let errorMessage = 'Failed to do something exceptional';
      if (error instanceof Error) {
        errorMessage = error.message;
      }
      this.setError(errorMessage);
    }
  }

  /**
   * アクションパネルのボタンを押下した際の次処理を進める
   * @param {string} - イベント情報として押下したボタン種類が返ってくる
   */
  private async buttonAction(type: any) {
    try {
      // 全要素ReadOnlyアクションか判定
      // const isReadOnly = orderApplyAbove.includes(type);
      const targetButton = this.statusButton.find(v => v.display_id === type);
      const crudType = targetButton?.crud_type || '';
      this.buttonCrudType = targetButton?.crud_type || '';
      if (crudType !== '4') {
        this.buttonText = this.editText;
        this.buttons = this.editButtons;
      } else {
        // コピー実施の場合：現状未使用
        this.buttonText = this.registerText;
        this.buttons = this.registerbuttons;
        this.$delete(this.registData.item, 'Status');
        this.$delete(this.registData.item, 'id');
        if (this.departFieldsData !== undefined) {
          this.departFieldsData.splice(-this.departFieldsData.length);
        }
        if (this.matterFieldsData !== undefined) {
          this.matterFieldsData.splice(-this.matterFieldsData.length);
        }
      }
      // ローディングをセット
      this.$store.commit('hexabase/setIsLoading', true);

      // アクション毎の見出し要素入力制限反映
      const copy = this.customer.modifyButtonProp(this.execAllowActions, type);
      if (copy !== undefined && copy.length > 0) {
        this.execAllowActions.splice(0, copy.length, ...copy);
      }
      const execAction = this.execAllowActions.find(action => action.display_id === type);
      if (execAction !== undefined) {
        this.selectAction = execAction.display_id;
        // ToDo 自動生成を使用する場合
        const result = (await this.modifyFields(
          this.mainDsId,
          this.basicFieldsData,
          execAction,
          type
        )) as Array<FieldChildrenProp>;
        this.basicFieldsData = result;
      }

      // 削除処理の場合、新規登録ボタンを非活性に
      if (type !== undefined && type === 'customer_valid_delete') {
        this.statusButton2[0].isDisable = true;
        this.statusButton3[0].isDisable = true;
      }
    } catch (error) {
      let errorMessage = 'Failed to do something exceptional';
      if (error instanceof Error) {
        errorMessage = error.message;
      }
      this.setError(errorMessage);
    } finally {
      this.statusButton = [
        ...this.customer.statusButtonList(this.execAllowActions, this.currentData, type)
      ];
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  /**
   * アクションパネルのボタンを押下した際の次処理を進める
   * @param {string} - イベント情報として押下したボタン種類が返ってくる
   */
  private async execAction(type: string) {
    /** 停止フラグ **/
    let StpFlg: boolean | undefined = false;

    switch (type) {
      case 'cancel': {
        this.$router.go(0);
        break;
      }
      case 'exec': {
        try {
          // ローディングをセット
          this.$store.commit('hexabase/setIsLoading', true);
          this.registerText = '';
          // objectでインサートされるのを回避
          if (typeof this.registData.item.payment_information_id === 'object') {
            this.registData.item.payment_information_id = '';
          }

          //重複チェックの呼び出し 削除モード時は重複チェックを行わない
          StpFlg =
            this.selectAction !== 'customer_valid_delete' ? await this.isDuplicated() : false;

          //重複判定後
          if (StpFlg) {
            //保存中断
            return false;
          } else {
            //保存続行
            await this.execDataRegister(false);
          }
        } catch (error) {
          let errorMessage = 'Failed to do something exceptional';
          if (error instanceof Error) {
            errorMessage = error.message;
          }
        } finally {
          this.$store.commit('hexabase/setIsLoading', false);
          if (!StpFlg) {
            //正常終了もしくはエラー終了時は終了・遷移ダイアログ
            this.dialogStatus = true;
          } else {
            //重複発生時は重複確認ダイアログ
            this.isExecDialog = true;
          }
        }
        break;
      }
      default: {
        break;
      }
    }
  }

  /**
   * 重複判定部
   * 「顧客名」「電話番号」の組み合わせで重複判定を行う
   * @returns {boolean} 重複有りの場合true
   */
  private async isDuplicated() {
    try {
      // 顧客名重複対象リスト
      let retFlg = false;
      await this.customer.getMasterData();
      const masterData = this.customer.getMaster();
      const alreadyData = masterData.m_customer.body.filter(
        v =>
          v.customer_name === this.registData.item['customer_name'] &&
          v.Status === '有効' &&
          v.i_id !== this.itemId
      );
      // 電話番号重複対象リスト
      const chkTelno =
        this.registData.item['telephone_number'] !== undefined
          ? this.registData.item['telephone_number'].replace(/-/g, '')
          : '';
      if (alreadyData !== undefined && alreadyData.length !== 0) {
        if (chkTelno === undefined || chkTelno.length === 0) {
          retFlg = true;
        } else {
          alreadyData.forEach(i => {
            if (
              i.telephone_number !== undefined &&
              i.telephone_number.replace(/-/g, '') === chkTelno
            ) {
              retFlg = true;
            }
          });
        }
      }
      return retFlg;
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * アイテムを登録後ダイアログ表示等を初期化します
   * @returns {void} - 内部プロパティ変更
   */
  private registerFinish(): void {
    this.dialogStatus = false;
    this.isLoading = false;
  }

  async modifyFields(
    dbId: string,
    data: Array<FieldChildrenProp> | Array<FieldChildrenProp[]>,
    execAction: ActionButtons,
    type: string
  ) {
    const inputFields = await this.customer
      .getFieldsByActionId(dbId, execAction.action_id)
      .then(data => {
        return data;
      });

    this.modifyFieldsSub(data as Array<FieldChildrenProp>);

    data = this.addInputRules(
      data as Array<FieldChildrenProp>,
      inputFields.action_field_settings,
      type
    );
    return this.modifyInputAllow(data, inputFields.action_field_settings) as Array<
      FieldChildrenProp
    >;
  }

  modifyFieldsSub(fields: Array<FieldChildrenProp>) {
    this.enablePersonalCol = false;
    this.enableCorporateCol = false;

    const index = fields.findIndex(v => v.display_id === 'customer_class');
    const chkValue = fields[index].props?.value;
    const chkSelect: Array<any> = fields[index].props?.selectData.options;
    const chkText = chkSelect.find(v => v.option_id === chkValue).text;
    if (chkText !== undefined && chkText === '個人') {
      this.enablePersonalCol = true;
      this.enableCorporateCol = false;
    } else {
      this.enablePersonalCol = false;
      this.enableCorporateCol = true;
    }
    return fields;
  }

  addInputRules(
    fields: Array<FieldChildrenProp>,
    fieldSetting: { [k: string]: ActionFieldSeeting },
    type: string
  ) {
    return fields.map(field => {
      if (field.props === undefined) return field;

      const ruleArray = [];

      // Hexa側設定必須項目
      if (fieldSetting[field.field_id] !== undefined) {
        // 必須項目確認
        if (fieldSetting[field.field_id].mandatory) {
          const requiredName = field.component === 'SelectArea' ? 'selectRequired' : 'required';
          ruleArray.push(requiredName);
        }
      }

      // アプリ側設定項目
      if (this.statusRules !== undefined && this.statusRules[type] !== undefined) {
        const row = this.statusRules[type].find(val => val.id === field.display_id);
        if (row !== undefined) {
          ruleArray.push(row.rule);
        }
      }

      if (
        customerRules.customer_edit !== undefined &&
        customerRules.customer_edit[type] !== undefined
      ) {
        const row = customerRules.customer_edit[type].find(val => val.id === field.display_id);
        if (row !== undefined) {
          ruleArray.push(row.rule);
        }
      }

      if (field.props!['rules'] === undefined) {
        field.props!['rules'] = '';
      }
      if (ruleArray.length > 0) field.props!['rules'] = ruleArray.join('|');
      return field;
    });
  }

  modifyInputAllow(
    fields: Array<FieldChildrenProp>,
    fieldSetting: { [k: string]: ActionFieldSeeting }
  ) {
    return fields.map(field => {
      if (fieldSetting[field.field_id] !== undefined) {
        const row = fieldSetting[field.field_id];
        if (row.update) {
          field.props! = { ...field.props!, ...{ isDisabled: false, isReadonly: false } };
        }
        if (field.dataType === 'dslookup') {
          field.props!.isBtnVisible = true;
          field.props!.isLeftSideInputReadOnly = false;
        }
        this.unshowdId.forEach(i => {
          if (field.display_id === i) {
            row.show = this.enablePersonalCol;
          }
        });
        // 顧客区分が法人・個人で表示、非表示を切替
        this.unshowdCorporateId.forEach(i => {
          if (field.display_id === i) {
            row.show = this.enableCorporateCol;
            // バリデーションルールの設定と削除
            if (this.enableCorporateCol === true) {
              this.$set(field.props!, 'rules', 'numeric|corporate_number_lengthCheck:13');
            } else {
              this.$set(field.props!, 'rules', '');
            }
          }
        });

        field = {
          ...field,
          ...{
            show: row.show,
            update: row.update,
            mandatory: row.mandatory
          }
        };
      }
      return field;
    });
  }

  /**
   * 関連付けされた部署（本社）の更新データ作成
   */
  /* eslint-disable prefer-const */
  private async setLinkedDepartData() {
    let CustomerDepertitem: EditCustomerDepertitem = {
      postal_code: '',
      prefectures: '',
      municipalities: '',
      machimura_street_address: '',
      building_name: '',
      manager: '',
      manager_email: '',
      telephone_number: '',
      cell_phone_number: '',
      rev_no: ''
    };

    try {
      this.$set(CustomerDepertitem, 'postal_code', this.registData.item['postal_code']);
      this.$set(CustomerDepertitem, 'prefectures', this.registData.item['prefectures']);
      this.$set(CustomerDepertitem, 'municipalities', this.registData.item['municipalities']);
      this.$set(
        CustomerDepertitem,
        'machimura_street_address',
        this.registData.item['machimura_street_address']
      );
      this.$set(CustomerDepertitem, 'building_name', this.registData.item['building_name']);
      this.$set(CustomerDepertitem, 'manager', this.registData.item['manager']);
      this.$set(CustomerDepertitem, 'manager_email', this.registData.item['manager_email']);
      this.$set(CustomerDepertitem, 'telephone_number', this.registData.item['telephone_number']);
      this.$set(CustomerDepertitem, 'cell_phone_number', this.registData.item['cell_phone_number']);
      return CustomerDepertitem;
    } catch (error) {
      console.log(error);
      this.setError(error);
    }
  }
  /* eslint-enable prefer-const */

  private setError(errorMessage: string): void {
    if (typeof errorMessage === 'object') errorMessage = this.customer.getDefaultErrorMessage();
    // エラーをキャッチした際共通エラーダイアログにセット
    this.$store.commit('hexabase/setIsError', true);
    this.$store.commit('hexabase/setErrorMessage', errorMessage);
  }

  /**
   * 重複ダイアログ
   */
  private async clearExecDialog(response: any): Promise<boolean> {
    this.isExecDialog = false;
    if (response !== undefined && response.isAgree) {
      //確認後強行パターン
      await this.execDataRegister(true);
    }
    return true;
  }

  /**
   * 登録実行部：再利用するため外部に切り出し
   *
   **/
  private async execDataRegister(toDialog: boolean): Promise<boolean> {
    try {
      if (toDialog) {
        this.$store.commit('hexabase/setIsLoading', true);
      }

      //顧客区分が法人の場合「生年月日＆性別」をクリアする
      if (this.registData.item['customer_class'] === this.referenceValue.customer_class_houjin) {
        // 生年月日
        if (this.registData.item['birthday'] !== undefined) {
          this.$delete(this.registData.item, 'birthday');
        }
        // 性別
        if (this.registData.item['sex'] !== undefined) {
          this.$delete(this.registData.item, 'sex');
        }
      } else {
        // 法人番号をクリア
        if (this.registData.item['corporate_number'] !== undefined) {
          this.$delete(this.registData.item, 'corporate_number');
        }
      }
      // 本社の顧客部署を呼び出して更新データをセット
      const setDepartDataValue = await this.setLinkedDepartData();
      if (this.departHontenId !== undefined && setDepartDataValue !== undefined) {
        this.$set(this.registData.related_ds_items, this.relatedDsIdDep, [
          {
            operation: 2,
            link_to_parent: true,
            i_id: this.departHontenId,
            item: setDepartDataValue,
            rev_no: Number(this.departHontenrevno)
          }
        ]);
      }
      const response =
        this.buttonCrudType !== '4'
          ? await this.customer.execStatusAction(
              this.registData,
              hexabaseState.applicationId,
              this.mainDsId,
              this.relatedDsIdDep,
              this.itemId,
              this.execAllowActions,
              this.execAllowActionsByDetail,
              this.revNumber,
              this.selectAction
            )
          : await this.customer.registerLinkedItems(
              hexabaseState.applicationId,
              this.mainDsId,
              this.registData
            );

      if (this.buttonCrudType === '4') {
        this.customer.apiErrorHandle('CREATEITEM', response);
        this.buttons.splice(0);
        this.buttons.push({
          id: 1,
          type: 'routing',
          color: 'primary',
          value: '詳細画面へ',
          route: `/matter/edit/${response.item_id}`
        });
      }
      //
      if (response !== undefined && response.text !== undefined && response.text.length > 0) {
        this.buttonText = response.text;
      }
      if (response !== undefined && response.button !== undefined) {
        this.buttons.splice(0);
        this.buttons.push(response.button);
      }
    } catch (error) {
      console.log(error);
      this.setError(error);
    } finally {
      if (toDialog) {
        this.$store.commit('hexabase/setIsLoading', false);
        this.dialogStatus = true;
      }
    }
    return true;
  }

  /**
   * ダイアログ
   */
  private async clearExecDialog2(response: any): Promise<boolean> {
    this.isExecDialog2 = false;
    const diwk: string = this.customer.deepCopy(this.waitingForDialog);
    const jpwk: string = this.customer.deepCopy(this.jumpIid);
    this.waitingForDialog = '';
    this.jumpIid = '';
    if (response !== undefined && response.isAgree) {
      switch (diwk) {
        case 'MatRegist':
          // 案件基本情報登録へ
          this.$router.push({
            name: 'MatterRegisterWithId',
            params: { id: this.itemId },
            query: {}
          });
          break;
        case 'MatEdit':
          // 案件基本情報編集へ
          this.$router.push({ name: 'MatterEdit', params: { id: jpwk }, query: {} });
          break;
        case 'DepRegist':
          // 顧客部署登録へ
          this.$router.push({
            name: 'CustomerDepartmentRegister',
            params: { id: this.itemId },
            query: {}
          });
          break;
        case 'DepEdit':
          // 顧客部署編集へ
          this.$router.push({ name: 'CustomerDepartmentEdit', params: { id: jpwk }, query: {} });
          break;
      }
      //確認後強行パターン
      await this.execDataRegister(true);
    }
    return true;
  }
  /**
   * 前画面に戻る
   */
  private movePrevious() {
    this.$router.back();
  }
}
